import { queryOptions } from '@tanstack/react-query';
import type { AssetUserType } from '@/common/asset';
import { axios } from '@/lib/utils/axios';
import { getResponse } from '../../common';
import { API_URLS } from '../../query.client';

export type AssetUserListSuccessResponse = AssetUserType[];

export type AssetUsersQueryParams = {
	/** Allowlisted `field:asc|desc` pairs, see ASSET_USER_SORT_FIELDS in the backend DTO. */
	sort?: string;
};

export async function getListAssetUsers(
	assetId: string,
	params: AssetUsersQueryParams = {},
): Promise<AssetUserListSuccessResponse | null> {
	const response = await axios.get(`${API_URLS.ASSETS.USERS(assetId)}`, { params });
	return getResponse<AssetUserListSuccessResponse>(response.data);
}

export const useQueryListAssetUsersOptions = (assetId: string, params: AssetUsersQueryParams = {}) => {
	return queryOptions({
		queryKey: ['assets', assetId, 'users', params],
		queryFn: () => getListAssetUsers(assetId, params),
		enabled: !!assetId,
	});
};
